
import { VirtualMachine } from "@/models/VirtualMachine";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class EditVirtualMachine extends Vue {
  @Prop({
    required: true,
  })
  private vm!: VirtualMachine;
  @Prop({
    required: true,
  })
  private vmIndex!: number;
  private inputDescription: string = '';
  private showCpuPercentageError: boolean = false;
  private showCpuIntervalError: boolean = false;
  async saveSchedule(vm: VirtualMachine) {
    vm.changingAutoShutdownSchedule = true;
    var params = this.$route.params;
    var token = await this.$store.state.authModule.getapiTokenPopup();
    await vm.updateVmAutoShutdownSchedule(
      params.subscriptionId,
      params.resourceGroupName,
      token
    );
    vm.changingAutoShutdownSchedule = false;
  }

  async updateDescriptionTag(vm: VirtualMachine) {
    if (this.inputDescription && this.inputDescription.length >= 256)
      return;
    vm.description = this.inputDescription;
    vm.updatingDescriptionTag = true;
    var params = this.$route.params;
    var token = await this.$store.state.authModule.getapiTokenPopup();
    await vm.updateDescriptionTag(
      params.subscriptionId,
      params.resourceGroupName,
      token,
    );
    vm.updatingDescriptionTag = false;
  }

  get inputDescriptionButtonDisabled() {
    return this.inputDescription && this.inputDescription.length >= 256;
  }

  validateKeyDown(event: any) {
    return event.charCode == 8 || event.charCode == 0 || event.charCode == 13
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  async saveCPUSchedule(vm: VirtualMachine) {
    if (
      vm.autoShutdownCPUSchedule.cpuPercentage < 1 ||
      vm.autoShutdownCPUSchedule.cpuPercentage > 20
    ) {
      this.showCpuPercentageError = true;
      return;
    }
    this.showCpuPercentageError = false;
    if (vm.autoShutdownCPUSchedule.intervalInHours < 1) {
      this.showCpuIntervalError = true;
      return;
    }
    this.showCpuIntervalError = false;
    vm.changingAutoShutdownCPUSchedule = true;
    var params = this.$route.params;
    var token = await this.$store.state.authModule.getapiTokenPopup();
    await vm.updateVmAutoShutdownCPUSchedule(
      params.subscriptionId,
      params.resourceGroupName,
      token
    );
    vm.changingAutoShutdownCPUSchedule = false;
  }
  created() {
    this.inputDescription = this.vm.description;
  }
}
